import enpointLookupAdapter from '../../../infrastructure/helpers/functions/lookup/enpointLookupAdapter';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import SelectOption from '../../../infrastructure/types/SelectOption';
import { SelectSearchOption } from 'react-select-search';
import dataSourceHelper from '../../../infrastructure/helpers/functions/common/dataSourceHelper';
import IngestionConfigOption from '../../../types/ingestion/IngestionConfigOption';
import pseudocodeHelper from '../../../infrastructure/helpers/functions/common/pseudocodeHelper';
import lookupHelper from '../../../infrastructure/helpers/functions/lookup/lookupHelper';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import operandHelper from '../../../infrastructure/helpers/functions/operand/operandHelper';
import Condition from '../../../types/functions/Condition/Condition';
import Lookup from '../../../types/functions/Lookup';
import Operand from '../../../types/functions/Operand/Operand';
import GlobalModuleConfig from '../../../types/report/GlobalModuleConfig';
import Mode from '../../../types/report/Mode';
import RefDataSource from '../../../types/report/RefDataSource';
import ReportConfig from '../../../types/report/ReportConfig';
import UserDefinedFunction from '../../../types/report/UserDefinedFunction';
import { getByConditionReferencesInGlobalConfig } from '../GlobalModule/GlobalModule.Helpers';
import ComponentType from '../../../types/report/ComponentType';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import Component from '../../../types/common/Component';
import CustomDropdownOption from '../../Common/Dropdown/CustomDropdownOption';
import reportLogicReferenceHelper from '../../../infrastructure/helpers/functions/report/reportLogicReferenceHelper';
import { reportType } from '../../../infrastructure/constants/reportType';
import ReportCollections from '../../../infrastructure/types/Functions/ReportCollections';
import { buildText } from '../Common/ReferenceComponentHelper/ReferenceComponentHelper';
import referenceHelper from '../../Common/Modals/ReferencesModal/ReferenceModal.Helpers';
import dataType from '../../../infrastructure/constants/dataType';

const getDefaultValueByDatType = (operandDataType: string): any => {
    switch (operandDataType) {
        case dataType.string: return '';
        case dataType.boolean: return true;
        case dataType.date: return '2026/01/01';
        case dataType.dateTime: return '2026/01/01T00:00:00';
        case dataType.unixTime: return Math.floor(new Date('2026-01-01T00:00:00').getTime() / 1000);
        case dataType.integer:
        case dataType.decimal: return 1;
        default:
            return '';
    }
}

const getDataType = (fieldId: number, collections: ReportCollections): string => {
    let field = collections.dataSources.map(x => x.fieldDefinitions).flat().find(f => f.id === fieldId);

    return field?.type || '';
}

const createDataSourceOption = (dataSource: IngestionConfig): SelectOption => {
    return {
        text: dataSource.name,
        value: (dataSource.id as number).toString()
    };
};

const lookupTypeOtions: SelectOption[] = [

    { value: false.toString(), text: 'Regular' },
    { value: true.toString(), text: 'Multi Result' }
];

const endpointLookupOption: SelectOption = {
    text: 'Report',
    value: enpointLookupAdapter.specialValue
};


const findReferencedComponentsInLookups = (globalModuleConfig: GlobalModuleConfig,
    reportConfig: ReportConfig,
    globalLookupModuleId: number,
    dataSourcesIds: Set<number>,
    referencedLookups: Lookup[],
    referencedUdfs: UserDefinedFunction[],
    missingDataSourcesMap: Map<number, string>): void => {

    let lookupNumber = globalModuleConfig.lookups.find(x => x.id === globalLookupModuleId)?.number as number;

    let lookupsIds = new Set<number>(reportConfig.lookups.map(x => x.globalLookupModuleId as number));

    let udfsIds = new Set<number>(reportConfig.userDefinedFunctions.map(x => x.globalUDFModuleId as number));

    getReferencesInGlobalConfig(globalModuleConfig, lookupNumber, dataSourcesIds, referencedLookups, referencedUdfs, lookupsIds, udfsIds);

    if (dataSourcesIds.size) {

        let configDataSources: number[] = reportConfig.refDataSources.map(x => x.id);
        configDataSources.push(reportConfig.rawDataSourceId || 0);

        dataSourcesIds.forEach((dataSourceId) => {
            if (!configDataSources.includes(dataSourceId)) {
                let ds = globalModuleConfig.refDataSources.find(x => x.id === dataSourceId);

                missingDataSourcesMap.set(dataSourceId, ds?.name as string);
            }
        });
    }
}


const prepareOptionsFromLookups = (lookups: Lookup[], datasources: IngestionConfigOption[]): SelectSearchOption[] => {

    let options: SelectSearchOption[] = [];
    lookups.forEach((lookup) => {
        let dataSource = dataSourceHelper.getById(datasources as IngestionConfig[], lookup.dataSource2Id as number);
        const name = dataSource?.name || '';
        var displayText = pseudocodeHelper.wrapInBrackets(lookupHelper.getName(lookup, name));
        options.push({
            name: displayText,
            value: displayText,
            items: [{ name: lookup.number.toString(), value: lookup.number.toString() }]
        });
    });

    return options;
}

const getReferencedLookupsIds = (globalLookups: Lookup[]): number[] => {

    let result = new Set<number>();

    globalLookups.forEach((lookup) => {
        operandHelper.proceedWhitCondition(lookup.condition, (operand: Operand) => {
            if (operand.lookupNumber) {
                let referenced = globalLookups?.find(x => x.number === operand.lookupNumber)?.id as number;

                result.add(referenced);
            }
        });
    });

    return Array.from(result);
}

const prepareOptionsFromGlobalLookups = (globalLookups: Lookup[], reportConfigDatasources: RefDataSource[], configLookups: Lookup[]): SelectSearchOption[] => {

    let options: SelectSearchOption[] = [];

    if (!globalLookups || globalLookups.length === 0) {
        return options;
    }

    let datasourceIds = new Set(reportConfigDatasources.map(x => x.id));

    let configLookupsIds = configLookups.map(x => x.globalLookupModuleId);

    let referencedLookups = getReferencedLookupsIds(globalLookups);

    let lookupsMatchingConfigDatasources = globalLookups.filter(x => !configLookupsIds.includes(x.id as number))
        .filter(x => referencedLookups.includes(x.id as number) ||
            (datasourceIds.has(x.dataSource1Id as number) && datasourceIds.has(x.dataSource2Id as number)));

    lookupsMatchingConfigDatasources = lookupsMatchingConfigDatasources.sort((prev, next) => prev.number - next.number);

    lookupsMatchingConfigDatasources.forEach((globalLookup) => {

        let lookupName = `L${globalLookup.number}-${globalLookup.name}`;

        options.push({
            name: lookupName,
            value: globalLookup?.id ? globalLookup.id.toString() : '',
            items: [{ name: lookupName, value: globalLookup?.id ? globalLookup.id.toString() : '' }]
        });
    });

    return options;
}


const prepareWarningMessageOnGlobalLookupAdd = (referencedDataSources: string[], referencedLookups: Lookup[], referencedFunctions?: UserDefinedFunction[]): string => {

    let message = '';

    let missingDataSources = referencedDataSources.map(x => `"${x}"`).join(', ');

    let missingLookups = referencedLookups.map(x => `"${x.name}"`).join(', ');

    let missingFunctions = referencedFunctions?.map(x => `"${x.name}"`)?.join(', ');

    if (missingDataSources || missingLookups || missingFunctions) {

        let dataSourcesMessage = missingDataSources ? `Please add datasources: ${missingDataSources}.\n` : '';

        let lookupsMessage = missingLookups ? `Please add referenced Lookups ${missingLookups}.\n` : '';

        message = `${dataSourcesMessage} ${lookupsMessage}\n\n`;
    }

    return message;
}

const getReferencedGlobalLookups = (reportConfig: ReportConfig, globalConfig: GlobalModuleConfig, lookupId: number): Lookup[] => {

    let lookup = globalConfig.lookups.find(x => x.id === lookupId) as Lookup;

    if (lookup) {

        let results: Lookup[] = [];

        traverseNestedLookups(lookup, globalConfig, reportConfig, results);

        return results;
    }

    return [];
}

const traverseNestedLookups = (lookup: Lookup, globalConfig: GlobalModuleConfig, reportConfig: ReportConfig, results: Lookup[]) => {
    operandHelper.proceedWhitCondition(lookup?.condition as Condition, ((operand: Operand) => {
        if (operand.lookupNumber) {
            let currentLookup = globalConfig.lookups.find(x => x.number === operand.lookupNumber) as Lookup;

            if (currentLookup && (results.length === 0 || (results.length > 0 && !results.find(x => x.id === currentLookup.id)))) {

                let existingInReportConfig = reportConfig.lookups.find(x => x.globalLookupModuleId === currentLookup.id);

                if (!existingInReportConfig) {
                    results.push(copyObject(currentLookup));

                    traverseNestedLookups(currentLookup, globalConfig, reportConfig, results);
                }
            }
        }
    }));
}

const getGlobalConfigReferencedDatasources = (configDataSources: number[], refDataSources: RefDataSource[], lookups: Lookup[]): Map<number, string> => {

    let missingDataSources: Map<number, string> = new Map();

    lookups.forEach((lookup) => {
        if (!configDataSources.includes(lookup.dataSource1Id as number)) {

            let dataSource = refDataSources.find(x => x.id === lookup.dataSource1Id);

            if (dataSource?.id) {
                missingDataSources.set(dataSource?.id as number, dataSource?.name || '');
            }
        }
        if (!configDataSources.includes(lookup.dataSource2Id as number)) {

            let dataSource = refDataSources.find(x => x.id === lookup.dataSource2Id);

            if (dataSource?.id) {

                missingDataSources.set(dataSource?.id as number, dataSource?.name || '');
            }
        }
    });

    return missingDataSources;
}

const prepareLookupsAndTheirReferences = (missingLookups: Lookup[], reportConfig: ReportConfig, mainLookup: Lookup, insertionNumber: number, oldAndNewNumbers?: Map<number, number>): Lookup[] => {

    if (!oldAndNewNumbers) {
        oldAndNewNumbers = new Map<number, number>();
    }

    let allLookups = prepareAllLookups(reportConfig, missingLookups, mainLookup, insertionNumber, oldAndNewNumbers);

    reportConfig.lookups = [];

    operandHelper.traverseReportConfigSectionsForOperands(reportConfig, (operand: Operand) => {
        if (operand.lookupNumber as number > 0 && oldAndNewNumbers.has(operand.lookupNumber as number)) {

            operand.lookupNumber = oldAndNewNumbers.get(operand.lookupNumber as number) as number;
        }
    });

    return allLookups;
}

const updateLookupConditions = (lookup: Lookup, lookupOldAndNewNumbers: Map<number, number>) => {
    operandHelper.proceedWhitCondition(lookup.condition, (operand: Operand) => {
        if (operand.lookupNumber as number > 0 && lookupOldAndNewNumbers.has(operand.lookupNumber as number)) {

            operand.lookupNumber = lookupOldAndNewNumbers.get(operand.lookupNumber as number) as number;
        }
    });
}


const addMissingLookups = (missingLookups: Lookup[], resulLookups: Lookup[],
    lookupsOldAndNewNumbers: Map<number, number>,
    number: number) => {
    missingLookups.forEach((lookup) => {

        lookup.globalLookupModuleId = lookup.id as number;

        lookup.id = null;

        lookup.mode = Mode.Global;

        lookup.isReadOnly = true;

        lookupsOldAndNewNumbers.set(lookup.number, number);

        lookup.number = number;

        number++;

        resulLookups.push(lookup);
    });

}

const addMainLookup = (mainLookup: Lookup, resultVariables: Lookup[]) => {

    mainLookup.id = null;

    resultVariables.push(mainLookup);
}

const updateLookupsConditions = (missingLookups: Lookup[], oldAndNewNumbers: Map<number, number>) => {

    missingLookups.forEach((l) => {
        updateLookupConditions(l, oldAndNewNumbers);
    });
}

const prepareAllLookups = (reportConfig: ReportConfig,
    missingLookups: Lookup[],
    mainLookup: Lookup,
    insertionNumber: number,
    lookupsOldAndNewNumbers: Map<number, number>): Lookup[] => {

    let newLookupsStartIndex = insertionNumber - missingLookups.length > 1 ?
        insertionNumber - missingLookups.length - 1 : 0;

    let missingLookupsCopy = copyArray(missingLookups);

    let reportConfigLookups = reportConfig.lookups.filter(x => x.globalLookupModuleId !== mainLookup?.globalLookupModuleId);

    let number = 0;

    if (missingLookupsCopy.length > 0) {

        let resultLookups = [] as Lookup[];

        let globalLookupsOldAndNewNumbers = new Map<number, number>();

        if (reportConfigLookups.length > 0) {
            for (let index = 0; index < reportConfigLookups.length; index++) {

                number++;

                let lookup = reportConfigLookups[index];

                if (missingLookupsCopy.length > 0 && (newLookupsStartIndex === index || newLookupsStartIndex + missingLookupsCopy.length <= index)) {

                    addMissingLookups(missingLookupsCopy, resultLookups, globalLookupsOldAndNewNumbers, number);

                    updateLookupsConditions(missingLookupsCopy, globalLookupsOldAndNewNumbers);

                    addMainLookup(mainLookup, resultLookups);

                    updateLookupConditions(mainLookup, globalLookupsOldAndNewNumbers);

                    number = mainLookup.number + 1;

                    if (index < reportConfigLookups.length - 1) {

                        lookupsOldAndNewNumbers.set(lookup.number, number);

                        lookup.number = number;

                        resultLookups.push(lookup);

                        index += 1;

                        missingLookupsCopy = [];
                    }
                }
                else {
                    lookupsOldAndNewNumbers.set(lookup.number, number);

                    lookup.number = number;

                    resultLookups.push(lookup);
                }
            }
        }
        else {
            let number = 1;

            addMissingLookups(missingLookupsCopy, resultLookups, globalLookupsOldAndNewNumbers, number);

            mainLookup.number = missingLookupsCopy.length + 1;

            addMainLookup(mainLookup, resultLookups);
        }

        return resultLookups;
    }
    else {
        return reportConfigLookups.concat(mainLookup);
    }
}

const getLookupReferences = async (number: number, reportConfig: ReportConfig, collections: ReportCollections): Promise<CustomDropdownOption[]> => {

    let config = copyObject(reportConfig);

    config.lookups = config.lookups.filter(x => x.number !== number);

    let references = reportLogicReferenceHelper.getLookupReferences(number, config, collections);

    let options: CustomDropdownOption[] = references.map((x) => { return { asUrl: false, component: { htmlId: x.value, name: x.text, componentType: x.componentType, componentNumber: x.number, reportConfigId: x.configId, componentInnerType: x.innerType, mainComponentNumber: x.mainComponentNumber } as Component } });

    let reportConfigsReferences = await getReportConfigsLookupReferences(number, reportConfig) || [];

    options = await options.concat(reportConfigsReferences);

    return options;
}

const getReportConfigsLookupReferences = async (number: number, reportConfig: ReportConfig): Promise<CustomDropdownOption[]> => {

    let options = [] as CustomDropdownOption[];

    if (reportConfig.type === reportType.globalModule) {

        let lookup = reportConfig.lookups.find(x => x.number === number);

        if (lookup?.id) {

            let component = { componentInnerType: ComponentType.Lookup, componentType: ComponentType.Lookup, componentId: lookup?.id, reportConfigId: reportConfig.id as number, componentNumber: lookup?.number } as Component;

            let refs = await referenceHelper.getGlobalReferences(component);

            refs.forEach((ref) => {
                ref.name = buildText(ref.reportConfigName || '', ref.name || '', ref.componentType);
                options.push({
                    component: ref,
                    asUrl: true
                } as CustomDropdownOption);
            });
        }
    }

    return options;
}



const validateDataSourceChange = async (lookupNumber: number, reportConfig: ReportConfig, collections: ReportCollections): Promise<string> => {

    let references = await getLookupReferences(lookupNumber, reportConfig, collections);

    let validationError = '';

    if (references.length) {
        validationError += 'The lookup is referenced in":\r\n';

        references.forEach((ref) => {

            validationError += `${ref.component.name}\r\n`;
        });

        validationError += 'Please remove references first.';
    }

    return validationError;
}

const getReferencesInGlobalConfig = (globalConfig: GlobalModuleConfig,
    number: number,
    dataSourceIds: Set<number>,
    resultLookups: Lookup[],
    resulFunctions: UserDefinedFunction[],
    existingInReportConfigLookupsIds: Set<number>,
    existingInReportConfigUdfsIds: Set<number>,
): void => {

    let lookup = globalConfig.lookups.find(x => x.number === number);

    if (lookup?.condition) {
        getByConditionReferencesInGlobalConfig(globalConfig,
            lookup.condition,
            resultLookups,
            resulFunctions,
            dataSourceIds,
            existingInReportConfigLookupsIds,
            existingInReportConfigUdfsIds
        );
    }
};

const updateLookupToLookupReferences = (lookup: Lookup, globalModule: GlobalModuleConfig, reportConfig: ReportConfig): void => {

    operandHelper.proceedWhitCondition(lookup.condition, (operand: Operand) => {
        if (operand.lookupNumber) {

            let globalLookup = globalModule.lookups.find(x => x.number === operand.lookupNumber) as Lookup;

            let reportConfigLookup = reportConfig.lookups.find(x => x.globalLookupModuleId === globalLookup.id);

            if (reportConfigLookup) {
                operand.lookupNumber = reportConfigLookup.number;
            }
        }
    });
}

export {
    createDataSourceOption,
    lookupTypeOtions,
    endpointLookupOption,
    prepareOptionsFromLookups,
    prepareOptionsFromGlobalLookups,
    prepareWarningMessageOnGlobalLookupAdd,
    getReferencedGlobalLookups,
    prepareLookupsAndTheirReferences,
    getGlobalConfigReferencedDatasources,
    getReferencesInGlobalConfig,
    findReferencedComponentsInLookups,
    updateLookupToLookupReferences,
    getLookupReferences,
    validateDataSourceChange,
    getDefaultValueByDatType,
    getDataType
};